import { FC } from 'react';
import { Loader } from '@servicetitan/web-components';
import { Frame } from '@servicetitan/design-system';

import { Header } from '../../common/components/header/header';
import { EHModule } from '../api/eh.api';
import { LoadingFallback } from './loading-fallback';

interface EHModuleWrapperProps {
    module: EHModule;
}

export const EHModuleWrapper: FC<EHModuleWrapperProps> = ({ module }) => {
    return (
        <Frame header={<Header module={module} />}>
            <Loader
                cache
                loadingFallback={<LoadingFallback />}
                className="w-100"
                basename={module.basePath}
                data={{
                    appSettings: JSON.stringify(module.appSettings),
                    appScope: module.apiScope,
                    ehInjected: JSON.stringify(true),
                }}
                src={module.packageUrl}
            />
        </Frame>
    );
};
